// extracted by mini-css-extract-plugin
export default {"questionTitle":"_979b24c5ff27d424"};